<template>
  <v-app>
    <side-bar :is-drawer-open.sync="isDrawerOpen"></side-bar>
    <app-bar @appBarNavClick="isDrawerOpen = !isDrawerOpen"></app-bar>
    <v-main>
      <div class="app-content-container pa-4">
        <slot></slot>
      </div>
    </v-main>
    <app-footer v-if="app.config.footerShow" :content="app.config.footerContent"></app-footer>
    <loading-overlay :loading="app.loading" />
    <SnackBar />
    <MessageBox />
    <InputBox />
  </v-app>
</template>

<script setup>
import { useAppStore } from "@/store/app";
import SideBar from "./components/SideBar.vue";
import LoadingOverlay from "@/components/shared/LoadingOverlay.vue";
import AppFooter from "./components/AppFooter.vue";
import AppBar from "./components/AppBar.vue";
import MessageBox from "@/components/shared/MessageBox.vue";
import InputBox from "@/components/shared/InputBox.vue";
import SnackBar from '@/components/shared/SnackBar.vue'
import { ref } from 'vue'

const isDrawerOpen = ref(true)
const app = useAppStore()
</script>
